module.exports = __webpack_public_path__ + "assets1783936157458/img/unlock.388aeb36.svg";